<template>
  <div class="">
      <h2 class="h3">
        <slot name="headline"></slot>
      </h2>
    <ul class="list-unstyled">
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblMSISDN"></slot>
          </div>
          <div> {{ phoneFormatterWithSpaces(msisdn) }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblSimType"></slot>
          </div>
          <div>
            <slot :name="'txtSimType' + simType"></slot>
          </div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblSimStatus"></slot>
          </div>
          <div> {{ activated }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

import { phoneFormatterWithSpaces } from '@/mixins/formatters/phoneFormatter'

export default {
  name: 'SummarySimData',
  methods: { phoneFormatterWithSpaces },
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    simType: {
      type: String,
      default: 'E_SIM'
    },
    simActivated: {
      type: Boolean,
      default: false
    },
    msisdn: {
      type: String,
      default: ''
    }
  },
  computed: {
    activated () {
      if (this.simActivated) {
        return this.getSlotText('txtSimStatusActivated')
      } else {
        return this.getSlotText('txtSimStatusNotActivated')
      }
    }
  }
}
</script>

<style scoped>

</style>
